import BaseController from "sap/mcsuite/controller/BaseController";
import { Translator } from "./Translator";
import BaseTranslator from "./BaseTranslator";
import Component from "sap/mcsuite/Component";

export default class LabelTranslator extends BaseTranslator implements Translator {

    constructor(component: Component) {
        super(component);
        this.argKeys = ['concept', 'name'];
        this.translationTable = 'cfr_labels_bs';
    }

    /**
     * Translates the given arguments using the label translation table.
     * If no translation is found, returns the last argument or an empty string if no arguments are provided.
     * In this case, the last argument is typically a default value.
     * @param args - The arguments to translate, typically including concept and name.
     * @returns A promise that resolves to the translated string or a default value.
     */
    public async translate(...args: string[]): Promise<string> {
        const that = this as unknown as Component;
        return await that.translator.Label.getTranslationOrDefault(...args).catch(error => {
            console.error(`Error in LabelTranslator.translate: ${error}`);
            return args[args.length - 1] || "";
        });
    }

    public async preloadTranslations(): Promise<void> {
        const that = this as unknown as BaseController;
        const listBinding = that.getODataModel().bindList(`/${this.translationTable}`, undefined, undefined, undefined, {
            $select: 'concept,name,lang_de,lang_en,lang_es',
        });
        const data = await listBinding.requestContexts(0, Infinity);
        data.forEach(context => {
            const concept = context.getProperty('concept');
            const name = context.getProperty('name');
            const userModel = that.getModel("user");
            const locale = userModel.getProperty("/locale");
            if (locale.lower() === 'de') {
                var translations = context.getProperty('lang_de');
            } else if (locale.lower() === 'es') {
                var translations = context.getProperty('lang_es');
            } else {
                var translations = context.getProperty('lang_en');
            }
            this.translationCache.set([concept, name], translations);
        });
        return;
        }
    }
